import { render } from "./admissionProcedureListDetail.vue?vue&type=template&id=008ac5f8&ts=true"
import script from "./admissionProcedureListDetail.vue?vue&type=script&lang=ts"
export * from "./admissionProcedureListDetail.vue?vue&type=script&lang=ts"

import "./admissionProcedureListDetail.vue?vue&type=style&index=0&id=008ac5f8&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__